import { API_URL } from "./config";
import { useState, useEffect, useRef } from "react";
import { getDocsx, docx, setDocx, collectionx, queryx } from "./SubtaskNewServer"
import db from "./Firebase"
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import './Timelog.css';
import moment from 'moment-timezone';
import token from './Token';
import { mqttUpdate } from './mqttUtils';
import { buildReportFromTimerHistory, buildTimeReportDocument, createTimeReportId, createTimerHistoryEntry, submitTimerHistoryToServer } from './timeLogSubmission';
import GoalCompletionModal from './GoalCompletionModal';
import { fetchGoals } from './goalsApi';
import { createGoalCompletionForEntry } from './goalUtils';

function Timelog() 
{
    const [tasks, setTasks] = useState([])

    const [allTasks, setAllTasks] = useState([])
    const [allSubtasks, setAllSubtasks] = useState([])
    const [allSubSubs, setAllSubSubs] = useState([])

    const [selectedTask, setSelectedTask] = useState('')
    const [selectedSubtask, setSelectedSubtask] = useState('')
    const [selectedSubSubtask, setSelectedSubSubtask] = useState('')

    const [taskTags, setTaskTags] = useState('')
    const [allowFeedback, setAllowFeedback] = useState(0)
    const [bonusCoeff, setBonusCoeff] = useState(1)
    const [activeGoals, setActiveGoals] = useState([])
    const [pendingSubmission, setPendingSubmission] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const submissionInFlightRef = useRef(false)
    /*
        _id: "65ef20ca92a59839519ccfef"
        description: "Housekeeping activities"
        expired: "2025-03-10T17:00:00.000Z"
        expiredDate: {toDate: function, toString: function, toJSON: function}
        finish: 1
        id: "HOUSE"
        practicalId: "HOUSE-HG6ZYX-6SYJ8P-ZH71ZP-HI28FM-KE76XH-EL9HH0"
        sn: "HOUSE-HG6ZYX-6SYJ8P-ZH71ZP-HI28FM-KE76XH-EL9HH0"
        subs: [
            bonusCoeff: 1
            finish: 1
            initialFinish: 1
            originalFinish: 0
            originalTime: 0
            sn: "MIVE5P-K7Z1P3-MQD4WW-0J2573-PDVW3T-VFO2FS"
            sname: "Cook Dinner 2"
            subsubs: [] (0)
            tags: ""
            time: 0
            type: "subtask"
        ] (4)
        tname: "Housekeeping activities"
        totalReward: 2.5
        username: "thinhhoang"
        validFrom: {toDate: function, toString: function, toJSON: function}
    */
    const loadData = async () => {
    const querySnapshot = await getDocsx(queryx(collectionx(db, "subtasks")))
        if(querySnapshot.size === 0)
        {
            return
        }
        let tasks = []
        querySnapshot.forEach((doc) => {
            let data = doc.data()
            tasks.push(data)
        })
        
        setTasks(tasks)
        setAllTasks(tasks.map((task) => task.id))
    }

    useEffect(() => {
        loadData()
    }, [])

    useEffect(() => {
        let mounted = true
        const refreshActiveGoals = () => {
            fetchGoals(false)
                .then((goalData) => {
                    if (mounted) setActiveGoals(goalData)
                })
                .catch(() => {
                    // Manual time logging remains available if goal retrieval fails.
                })
        }
        refreshActiveGoals()
        const refreshInterval = window.setInterval(refreshActiveGoals, 5 * 60 * 1000)
        return () => {
            mounted = false
            window.clearInterval(refreshInterval)
        }
    }, [])

    const onTaskChange = (e) => {
        const taskId = e.target.value
        const task = tasks.find((item) => item.id === taskId)
        setSelectedTask(taskId)
        setSelectedSubtask('')
        setSelectedSubSubtask('')
        setAllSubSubs([])

        if (!task) {
            setAllSubtasks([])
            setTaskTags('')
            setAllowFeedback(0)
            setBonusCoeff(1)
            return
        }

        const snames = (task.subs || []).map((sub) => sub.sname)
        setAllSubtasks(snames)
    }

    const onSubtaskChange = (e) => {
        const subtask = e.target.value
        setSelectedSubtask(subtask)
        setSelectedSubSubtask('')

        const task = tasks.find((item) => item.id === selectedTask)
        if (!task) {
            setAllSubSubs([])
            setTaskTags('')
            setAllowFeedback(0)
            setBonusCoeff(1)
            return
        }

        const sub = (task.subs || []).find((item) => item.sname === subtask)
        if (!sub) {
            setAllSubSubs([])
            setTaskTags('')
            setAllowFeedback(0)
            setBonusCoeff(1)
            return
        }

        setAllSubSubs((sub.subsubs || []).map((entry) => entry.name))
        setTaskTags(sub.tags || '')
        setAllowFeedback(sub.allowFeedback > 0 ? sub.allowFeedback : 0)
        setBonusCoeff(sub.bonusCoeff ?? 1)
    }

    const onSubSubtaskChange = (e) => {
        const subsubtask = e.target.value
        setSelectedSubSubtask(subsubtask)
    }

    const [completionTime, setCompletionTime] = useState(moment().toISOString())
    const [completionTimeDisplay, setCompletionTimeDisplay] = useState(moment().format('DD/MM/YYYY HH:mm:ss'))
    const [duration, setDuration] = useState('')

    // Parse DD/MM/YYYY HH:MM:SS format to ISO string
    const parseDateInput = (input) => {
        if (!input || input.trim() === '') {
            return null
        }
        
        // Check if input is already in ISO format (backward compatibility)
        if (moment(input, moment.ISO_8601, true).isValid()) {
            return input
        }
        
        // Try to parse DD/MM/YYYY HH:MM:SS format
        const patterns = [
            'DD/MM/YYYY HH:mm:ss',
            'DD/MM/YYYY HH:mm',
            'DD/MM/YYYY',
            'DD-MM-YYYY HH:mm:ss',
            'DD-MM-YYYY HH:mm',
            'DD-MM-YYYY',
            'DD.MM.YYYY HH:mm:ss',
            'DD.MM.YYYY HH:mm',
            'DD.MM.YYYY'
        ]
        
        for (const pattern of patterns) {
            const parsed = moment(input, pattern, true)
            if (parsed.isValid()) {
                return parsed.toISOString()
            }
        }
        
        // If no pattern matches, try moment's default parsing
        const defaultParsed = moment(input)
        if (defaultParsed.isValid()) {
            return defaultParsed.toISOString()
        }
        
        return null
    }

    // Format ISO string to DD/MM/YYYY HH:MM:SS for display
    const formatDateForDisplay = (isoString) => {
        if (!isoString) {
            return ''
        }
        const m = moment(isoString)
        if (!m.isValid()) {
            return isoString // Return as-is if invalid
        }
        return m.format('DD/MM/YYYY HH:mm:ss')
    }

    const handleCompletionTimeChange = (e) => {
        const inputValue = e.target.value
        setCompletionTimeDisplay(inputValue)
        
        // Try to parse the input
        const parsedISO = parseDateInput(inputValue)
        if (parsedISO) {
            setCompletionTime(parsedISO)
        }
        // If parsing fails, we keep the display value but don't update the ISO value
        // This allows users to type without errors interrupting them
    }

    const resetForm = () => {
        setSelectedTask('')
        setSelectedSubtask('')
        setSelectedSubSubtask('')
        setAllSubtasks([])
        setAllSubSubs([])
        setTaskTags('')
        setAllowFeedback(0)
        setBonusCoeff(1)
        const nowISO = moment().toISOString()
        setCompletionTime(nowISO)
        setCompletionTimeDisplay(formatDateForDisplay(nowISO))
        setDuration('')
    }

    const submitPreparedLog = async ({ timerHistory, taskId, reportId, goalCompletions }) => {
        if (submissionInFlightRef.current) return
        submissionInFlightRef.current = true
        setSubmitting(true)

        try {
            const report = buildReportFromTimerHistory(timerHistory, taskId)
            if (report.length === 0) throw new Error('No task to save!')

            const finalReport = buildTimeReportDocument(report)
            await setDocx(docx(db, "reports", reportId), finalReport)

            const response = await submitTimerHistoryToServer({
                apiUrl: API_URL,
                token: token,
                timerHistory,
                taskId,
                reportId,
                goalCompletions,
            })
            if (!response.ok) throw new Error('Failed to submit report')

            setPendingSubmission(null)
            resetForm()
            loadData()
            try {
                await mqttUpdate()
                alert('Report submitted successfully')
            } catch (err) {
                console.error('MQTT update failed:', err)
                alert('Report submitted successfully (but MQTT notification failed)')
            }
        } finally {
            submissionInFlightRef.current = false
            setSubmitting(false)
        }
    }

    const submitPendingGoalCompletion = async (answersByGoal) => {
        if (!pendingSubmission) return
        const goalCompletions = pendingSubmission.goalCompletions.map((completion) => (
            completion.completionId === pendingSubmission.completion.completionId
                ? { ...completion, answersByGoal }
                : completion
        ))
        await submitPreparedLog({ ...pendingSubmission, goalCompletions })
    }

    const closePendingGoalCompletion = () => {
        submitPendingGoalCompletion([]).catch((error) => {
            alert(error.message || 'Failed to submit report')
        })
    }

    const submitForm = async () => {
        // Make sure the duration is not empty, selectedSubtask is not empty, selectedTask is not empty
        if (duration === '' || selectedSubtask === '' || selectedTask === '')
        {
            alert('Please fill in all the fields')
            return
        }
        
        // Validate and parse completion time
        const parsedISO = parseDateInput(completionTimeDisplay)
        if (!parsedISO) {
            alert('Please enter a valid completion time in format DD/MM/YYYY HH:MM:SS')
            return
        }
        
        // Update the completion time if it was parsed from display value
        if (parsedISO !== completionTime) {
            setCompletionTime(parsedISO)
        }
        
        let timeAccumulated = Number(duration) * 60000 // in milliseconds
        let mCompletionTime = moment(parsedISO).toISOString()

        if (!Number.isFinite(timeAccumulated)) {
            alert('Please enter a valid duration')
            return
        }

        const task = tasks.find((item) => item.id === selectedTask)
        const subtask = (task?.subs || []).find((item) => item.sname === selectedSubtask)
        const subsubtask = selectedSubSubtask ? (subtask?.subsubs || []).find((entry) => entry.name === selectedSubSubtask) : null

        if (!task || !subtask || (selectedSubSubtask && !subsubtask)) {
            alert('Please refresh tasks and select the task again')
            return
        }

        const subsubPath = selectedSubtask + (selectedSubSubtask ? '/' + selectedSubSubtask : '')
        const baseEntry = createTimerHistoryEntry({
            subtask: subtask,
            highlighted: subsubPath,
            duration: timeAccumulated,
            done: moment(mCompletionTime).toDate()
        })
        const { entry, pendingCompletion, promptCompletion } = createGoalCompletionForEntry({
            entry: baseEntry,
            stampId: selectedTask,
            goals: activeGoals,
            timezone: localStorage.getItem('timezone') || moment.tz.guess(),
        })
        const preparedSubmission = {
            timerHistory: [entry],
            taskId: selectedTask,
            reportId: createTimeReportId(),
            goalCompletions: pendingCompletion ? [pendingCompletion] : [],
        }

        if (promptCompletion) {
            setPendingSubmission({ ...preparedSubmission, completion: promptCompletion })
            return
        }

        try {
            await submitPreparedLog(preparedSubmission)
        } catch (error) {
            alert(error.message || 'Failed to submit report')
        }
    }


    return(
        <div className='AppRootDesktop'>
            <div className='AppRootInnerOverlay'>
                <GoalCompletionModal
                    completion={pendingSubmission?.completion || null}
                    onClose={closePendingGoalCompletion}
                    onSubmit={submitPendingGoalCompletion}
                    displayMode='dialog'
                    statusText='Attempts and duration will be recorded with this time log.'
                />
                <div className='timelog-page edit-page'>
                    <div className='action-bar'>
                        <div className='action-bar-heading'>
                            <h1>Manual Time Log</h1>
                            <div className='action-bar-subtitle'>Capture ad-hoc work in a few clicks. Pick the task, record the duration, and submit.</div>
                        </div>
                        <div className='action-bar-controls'>
                            <Button variant='outline-light' onClick={loadData}>Refresh tasks</Button>
                        </div>
                    </div>

                    <Container fluid='lg' className='timelog-container'>
                        <Row className='g-4 timelog-grid'>
                            <Col xs={12} lg={7}>
                                <div className='task-card timelog-card'>
                                    <h2 className='section-title'>Log Details</h2>
                                    <Form>
                                        <Form.Group controlId='timelog-main-task' className='mb-3'>
                                            <Form.Label>Main Task</Form.Label>
                                            <Form.Select value={selectedTask} onChange={onTaskChange}>
                                                <option value=''>Select main task</option>
                                                {allTasks.map((task, index) => (
                                                    <option key={index} value={task}>{task}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group controlId='timelog-task' className='mb-3'>
                                            <Form.Label>Task</Form.Label>
                                            <Form.Select value={selectedSubtask} onChange={onSubtaskChange} disabled={!allSubtasks.length}>
                                                <option value=''>Select task</option>
                                                {allSubtasks.map((subtask, index) => (
                                                    <option key={index} value={subtask}>{subtask}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group controlId='timelog-subtask' className='mb-3'>
                                            <Form.Label>Subtask</Form.Label>
                                            <Form.Select value={selectedSubSubtask} onChange={onSubSubtaskChange} disabled={!allSubSubs.length}>
                                                <option value=''>Select subtask</option>
                                                {allSubSubs.map((subsub, index) => (
                                                    <option key={index} value={subsub}>{subsub}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group controlId='timelog-completion-time' className='mb-3'>
                                            <Form.Label>Completion Time</Form.Label>
                                            <Form.Control
                                                type='text'
                                                placeholder='DD/MM/YYYY HH:MM:SS'
                                                value={completionTimeDisplay}
                                                onChange={handleCompletionTimeChange}
                                                onBlur={(e) => {
                                                    // On blur, ensure we have a valid date
                                                    const parsedISO = parseDateInput(e.target.value)
                                                    if (parsedISO) {
                                                        setCompletionTime(parsedISO)
                                                        setCompletionTimeDisplay(formatDateForDisplay(parsedISO))
                                                    } else if (completionTime) {
                                                        // If parsing fails but we have a valid completionTime, restore display
                                                        setCompletionTimeDisplay(formatDateForDisplay(completionTime))
                                                    }
                                                }}
                                            />
                                            <Form.Text className='text-muted'>
                                                Format: DD/MM/YYYY HH:MM:SS (e.g., 15/11/2025 17:50:04)
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group controlId='timelog-duration' className='mb-4'>
                                            <Form.Label>Duration (minutes)</Form.Label>
                                            <Form.Control
                                                type='number'
                                                min='0'
                                                onChange={(e) => setDuration(e.target.value)}
                                                value={duration}
                                            />
                                        </Form.Group>

                                        <div className='button-group timelog-actions'>
                                            <Button variant='secondary' onClick={resetForm} type='button' disabled={submitting}>Clear</Button>
                                            <Button variant='primary' onClick={submitForm} type='button' disabled={submitting}>{submitting ? 'Submitting…' : 'Submit'}</Button>
                                        </div>
                                    </Form>
                                </div>
                            </Col>

                            <Col xs={12} lg={5}>
                                <div className='task-card timelog-summary'>
                                    <h2 className='section-title'>Current Selection</h2>
                                    <dl className='summary-list'>
                                        <div className='summary-item'>
                                            <dt>Main task</dt>
                                            <dd>{selectedTask || '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Task</dt>
                                            <dd>{selectedSubtask || '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Subtask</dt>
                                            <dd>{selectedSubSubtask || '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Completion time</dt>
                                            <dd>{completionTime ? moment(completionTime).format('YYYY-MM-DD HH:mm') : '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Duration</dt>
                                            <dd>{duration ? `${duration} min` : '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Tags</dt>
                                            <dd>{taskTags || '—'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Allow feedback</dt>
                                            <dd>{allowFeedback ? 'Yes' : 'No'}</dd>
                                        </div>
                                        <div className='summary-item'>
                                            <dt>Bonus coeff.</dt>
                                            <dd>{bonusCoeff}</dd>
                                        </div>
                                    </dl>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </div>
    )
}

export default Timelog
